export default __webpack_public_path__ + "a8ea452226b719abbb384323bd60d587.svg";